import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-API_LIST",
  "use": "icon-API_LIST-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-API_LIST\">\r\n    <defs>\r\n        <style type=\"text/css\"></style>\r\n    </defs>\r\n    <path d=\"M127 192c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64 35.346 0 64 28.654 64 64 0 35.346-28.654 64-64 64z m0 384c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64 35.346 0 64 28.654 64 64 0 35.346-28.654 64-64 64z m0 384c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64 35.346 0 64 28.654 64 64 0 35.346-28.654 64-64 64zM288 88h632c22.091 0 40 17.909 40 40s-17.909 40-40 40H288c-22.091 0-40-17.909-40-40s17.909-40 40-40z m0 384h632c22.091 0 40 17.909 40 40s-17.909 40-40 40H288c-22.091 0-40-17.909-40-40s17.909-40 40-40z m0 384h632c22.091 0 40 17.909 40 40s-17.909 40-40 40H288c-22.091 0-40-17.909-40-40s17.909-40 40-40z\" p-id=\"2886\" fill=\"#ffffff\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/API_LIST.svg
// module id = CsMu
// module chunks = 72